"use client";
import Link from "next/link";
import Menu from "../Menu";
import { useState } from "react";

export default function Header2({ handleToggle, scroll , pagesHeader }) {
  const [pages, setPages] = useState(pagesHeader || []);

  function getCurrentPath(id) {
    const currentPage = pages.find((item) => item.id === id);
    return {
      link: currentPage?.seo_permalink,
      title: currentPage?.title,
    };
  }

  return (
    <>
      {/* <Top2 /> */}
      <div
        className={`py-5 shadow-sm bg-white  z-50 ${scroll
          ? "fixed w-full left-0 right-0 top-0 transition-all bg-white"
          : ""
          }`}
      >
        <div className="container">
          <div className="flex gap-4 items-center justify-between ">
            <Link href="/" className="logo py-1">
              <img
                width={134}
                height={29}
                sizes="50vw"
                src="/images/vieillir-a-la-maison-logo.svg"
                alt="Vieillir à la maison, aide, soins à domicile"
              />
            </Link>

            <div className="items-center justify-end header-right hidden lg:flex lg:items-center lg:w-auto lg:space-x-12">
              <Menu pagesHeader={pagesHeader} />
              <Link
                className="hidden lg:block text-white btn bg-primary-1000 hover:bg-primary-1000 transition duration-150  rounded-md px-3 cursor-pointer whitespace-nowrap "
                href={"/" + getCurrentPath(62).link ?? "#"}
              >
                Besoin d&apos;aide ?
              </Link>
            </div>

            <div className="lg:hidden" onClick={handleToggle}>
              <button className="navbar-burger flex items-center py-2 px-3 text-primary-1000 hover:text-primary-1000 rounded border border-primary-1000 hover:border-primary-1000">
                <svg
                  className="h-4 w-4"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#ED2B50"
                >
                  <title>Mobile menu</title>
                  <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
